// #region router
import Vue from 'vue';
import Router from 'vue-router';
import { routerEnterGuard } from './guards';
import UserInfoTool from '../plugins/user-info-tool.js';

import HomeRoute from './modules/home.route'
import Login from '../views/login'
// import LoginAgency from '../views/login-agency'
import TotalPlatform from './modules/totalPlatform.route'
import Example from './modules/example.route'
import Operation from './modules/operation.route'
import Integral from './modules/integral.route'
import Member from './modules/member.route'
import Order from './modules/order.route'
import Storage from './modules/storage.route'
import newStorage from './modules/new-storage.route'
import Financial from './modules/financial.route'
import Audit from './modules/audit.route'
import Jurisdiction from './modules/jurisdiction.route'
import ShopTicket from './modules/shopTicket.route'
import Restrict from './modules/restrict.route'
import Statement from './modules/statement.route'
import ChangeCode from './modules/change-code.route'
import OperationLog from './modules/operation-log.route'
import Wrist from './modules/wrist.route'
import OperationManagement from './modules/operation-management.route'
// #endregion end

Vue.use(Router);

/**
 * 路由字段配置说明
 *
 * @param {Object} meta 路由元数据
 *
 * @param {Boolean} meta.unfold 是否可以在菜单栏展开
 * @param {Boolean} meta.hide 是否可以在菜单栏显示
 * @param {Boolean} meta.iconType 菜单栏图标
 *
 * @param {Boolean} children.meta.hide 是否可以在菜单栏显示
 *
 */

const router = new Router({
    routes: [
        {
            path:'/',
            redirect:"/login"
        },
        {
            path: '/login',
            name: 'login',
            meta: {
                name: '登录',
                hide: true,
                auth: false
            },
            component: Login
        },
        // {
        //     path: '/loginAgency',
        //     name: 'loginAgency',
        //     meta: {
        //         name: '聚合登录',
        //         hide: true,
        //         auth: false
        //     },
        //     component: LoginAgency
        // },
        /* {
            path: '/',
            redirect: {
                name: 'sitePages'
            },
            meta: {
                name: '场地管理',
                hide: true,
                auth: false
            },
        }, */
        /* {
            path: '*',
            redirect: "/loginAgency",
            meta: {
                name: '登录之前',
                hide: true,
                auth: false
            },
        }, */
    ]
        .concat(
            HomeRoute,
            TotalPlatform,
            Operation,
            ShopTicket,
            Integral,
            ChangeCode,
            Member,
            Order,
            // Restrict,
            // Storage,
            newStorage,
            Audit,
            Financial,
            // Wrist,
            Statement,
            Jurisdiction,
            // OperationLog,
            // Example,
            OperationManagement
        )
});

// router.beforeEach(routerEnterGuard);
// router.afterEach((to) => {
//     document.head.querySelector('title').innerText = to.meta.name;
// })

router.beforeEach((to, form, next) => {
    const isLogin = Boolean(UserInfoTool.getToken());
    if(to.path === '/loginAgency' || to.path === '/login') {
        return next();
    }
    if (isLogin) {
        next();
    } else {
        next('/login');
    }

})

router.onError((error) => {
    console.error('routerError:' + error);
    const pattern = /Loading chunk/g
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
})

export default router;
